<div class="my-applications-container">
  <div class="header-row">
    <span class="title">My Applications</span>
    <div class="actions">
      <button mat-icon-button class="icon-btn" title="Download">
          <svg class="download-icon" viewBox="0 0 24 24" fill="currentColor">
            <path d="M5 20h14v-2H5v2zm7-18c-1.1 0-2 .9-2 2v8H8l4 4 4-4h-2V4c0-1.1-.9-2-2-2z"/>
          </svg>
      </button>
      <button mat-icon-button class="icon-btn" title="Grid/List Toggle">
        <svg class="custom-icon" viewBox="0 0 19 15" fill="currentColor">
          <rect width="19" height="15" rx="2"/>
        </svg>
      </button>
  <button mat-raised-button color="primary" class="start-btn" (click)="openApplicationTypeDialog()">Start New Application</button>
    </div>
  </div>
  <table class="applications-table">
    <thead>
      <tr>
        <th>Application ID <mat-icon class="filter-icon">filter_list</mat-icon></th>
        <th>Application Type <mat-icon class="filter-icon">filter_list</mat-icon></th>
        <th>Date Created <mat-icon class="filter-icon">filter_list</mat-icon></th>
        <th>Action</th>
      </tr>
    </thead>
<tbody>
  <tr *ngIf="applications.length === 0" class="no-records-row">
    <td colspan="4" class="no-records">No records</td>
  </tr>
  <tr *ngFor="let app of applications">
    <td>{{ app.application_id }}</td>
    <td>{{ app.cd_application_type }}</td>
    <td>{{ app.created_date | date }}</td>
    <td><!-- Action buttons here --></td>
  </tr>
</tbody>
  </table>
</div>
